/* eslint-disable camelcase */
import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_create($course: CourseCreation) {
    Course_create(course: $course) {
      id
      name
      description
      updatedAt
      thumbnail
      isDraft
      Priority {
        name
      }
      CourseCategory {
        name
      }
      User {
        fullName
        photo
      }
    }
  }
`;

const courseSetEnterpriseType = async course =>
  graphql(mutation, { course }).then(({ Course_create }) => Course_create);

export default courseSetEnterpriseType;
